import React from 'react';
import AddressEditModal from './AddressEditModal';
import AddressReset from './AddressReset';
import NoAddressData from './NoAddressData';

// -- Address Row
function AddressRow({ title, data }) {
    return (
        <div className="w-full flex flex-row justify-start">
            <p className="w-3/12 text-sm text-primary/75 capitalize">{title}:</p>
            <p className="w-9/12 text-sm text-primary font-normal">{data}</p>
        </div>
    );
}

// -- Address Card
function AddressCard({ title, addressData, disabled }) {
    // -- check address data and set plus icon
    if (!addressData) {
        return <NoAddressData title={title} data={addressData} disabled={disabled} />;
    }
    // -- If address data is available
    return (
        <div
            className={`address-card flex flex-col gap-6 w-full min-h-[250px] p-5 border border-primary-100 rounded-2xl ${
                disabled ? 'grayscale pointer-events-none' : ''
            }`}
        >
            {/* Card Header */}
            <div className="flex flex-row gap-2 justify-between items-end">
                <h1 className="text-primary text-xl font-medium capitalize">{title}</h1>
                <div className="border-b border-primary-200 flex-[1]" />
                <div className="flex flex-row items-center gap-2">
                    <AddressReset data={addressData} />
                    <AddressEditModal data={addressData} title={title} />
                </div>
            </div>
            {/* Card Body */}
            <div className="flex flex-col gap-3">
                <AddressRow
                    title="Name"
                    data={`${addressData?.firstName} ${addressData?.lastName} `}
                />
                <AddressRow title="Organization" data={addressData?.organization} />
                <AddressRow title="Email" data={addressData?.email} />
                <AddressRow title="Phone" data={addressData?.phone} />
                <AddressRow
                    title="Address"
                    // data={
                    //     `${addressData?.address}, ${addressData?.state}, ${addressData?.city}, ${addressData?.zip}, ${addressData?.country}` ||
                    //     `No Address Data`
                    // }
                    // optimized to avoid trailing commas
                    data={
                        [
                            addressData?.address,
                            addressData?.city,
                            addressData?.state,
                            addressData?.zip,
                            addressData?.country
                        ]
                            .filter(Boolean)
                            .join(', ') || 'No Address Data'
                    }
                />
            </div>
        </div>
    );
}

export default AddressCard;
